import React from "react";
import PieEcharts from "./PieEcarts";
import Util, { ToastTime } from "../util";
import { withRouter, hashHistory } from "react-router";
import PositionList from "./PositionList";
import "./position.css";
import { connect } from "react-redux";
import { Toast } from 'antd-mobile/lib';

class Position extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  
  toSelectionPool = () => {
     window.open('https://app.amcfortune.com/wAppStatic/AlternativeFund.pdf')
    // window.location.href='https://app.amcfortune.com/wAppStatic/AlternativeFund.pdf'
  }; 
  toPositionDetails = () => {
    const { superFundItemFund4StyleTypeList = [], updateTimeStr = "" } = this.props;
    hashHistory.push({
      pathname: "/PositionDetails",
      query: {
        superFundItemFund4StyleTypeList,
        updateTimeStr,
      },
      state: {
        superFundItemFund4StyleTypeList,
        updateTimeStr,
      },
    });
  };
  toPublicOffering = (item) => {
    if (item.camcOrNonCamcWhiteListFundFlag === "0") return Toast.info("该产品暂不支持交易", ToastTime);
    hashHistory.push({ pathname: "/PublicOffering", query: { fundCode: item.fundCode }, state: { fundCode: item.fundCode } });
  };
  renderItem = (item) => (
    <div
      className="PositionPie_Item_container"
      key={item.fundCode}
      onClick={() => {
        this.toPublicOffering(item);
      }}
    >
      <span>{item.fundName}</span>
      <span>{item.fundCode}</span>
    </div>
  );
  header = (v) => (
    <div className="PositionPie_header_container" style={{ background: Util.pieEchartsFundListColorMap.get(v.styleTypeName) }}>
      <span className="PositionPie_title">{v.styleTypeName}</span>
      <span className="Position_totleValue">{Util.toPercent(v.totalRate)}</span>
      <div className="more_btn" onClick={this.toPositionDetails}>
        <span>共{v.subSuperFundItemList.length}只，查看全部</span>
        <img style={{ width: ".2rem" }} src={require("../img/n_icon_arrow_gray@2x.png")} />
      </div>
    </div>
  );
  render() {
    const { superFundItemFund4StyleTypeList = [], legendData = [], seriesData = [], updateTimeStr } = this.props;
    return (
      <div className="Position_container">
        <div className="Position_header">
          <span className="Position_title">策略持仓</span>
          <span>更新时间：{updateTimeStr}</span>
          <div className="SelectPool_btn" onClick={this.toSelectionPool}>
            <span>产品备选池</span>
            <img style={{ width: ".2rem" }} src={require("../img/n_icon_arrow_gray@2x.png")} />
          </div>
        </div>
        <PieEcharts height="140px" legendData={legendData} seriesData={seriesData} />
        <div>
          {superFundItemFund4StyleTypeList.map((v, i) => (
            <PositionList key={v.styleType} background={Util.pieEchartsFundListBgColorMap.get(v.styleTypeName)} header={this.header(v)} renderItem={this.renderItem} dataSource={v.subSuperFundItemList.slice(0, 3)} topDistance=".22rem" bottomDistance=".22rem" />
          ))}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { superFundBasicInfo = {} } = state.strategiesDetails;
  return {
    seriesData: superFundBasicInfo.seriesData,
    legendData: superFundBasicInfo.legendData,
    superFundItemFund4StyleTypeList: superFundBasicInfo.superFundItemFund4StyleTypeList,
    updateTimeStr: superFundBasicInfo.updateTimeStr,
  };
}
export default withRouter(connect(mapStateToProps)(Position));



// WEBPACK FOOTER //
// ./src/components/Position.js